import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./GuideTour.less');
const cx = classnames.bind(styles);

interface Props
{
}

interface State
{
    // panelClientRect:ClientRect;
}

@observer
export class GuideTour extends React.Component<Props, State>
{
    constructor(props:any)
    {
        super(props);

        // this.state = {panelClientRect: null};
    }

    // componentDidMount():void
    // {
    //     reaction(
    //         () =>
    //         {
    //             const {tour: guideTour} = controllers.ui.guide.getGuideState();
    //
    //             return guideTour ? guideTour.panelRef : null;
    //         },
    //         (elementRef:HTMLElement) =>
    //         {
    //             this.setState({
    //                 panelClientRect: elementRef ? elementRef.getBoundingClientRect() : null
    //             });
    //         }
    //     );
    // }

    private _onClickWrapper = () =>
    {
        controllers.ui.guide.setTourVisibility(false);
    };

    // private _renderText = (style:React.CSSProperties, text:string | JSX.Element):JSX.Element =>
    // {
    //     return (
    //         <div
    //             className={styles.textWrapper}
    //             style={style}
    //         >
    //             <div className={styles.text}>
    //                 {text}
    //             </div>
    //             <WSPIcon
    //                 className={styles.iconArrow}
    //                 name={WSPIcons.guide.Arrow}
    //             />
    //         </div>
    //     );
    // };

    public render():JSX.Element
    {
        // const {panelClientRect} = this.state;
        //
        // if( !panelClientRect ) return null;

        const {tour: {isVisible}} = controllers.ui.guide.getGuideState();

        if( !isVisible ) return null;

        // const {top, left, width, height} = panelClientRect;
        //
        // let _styleWelcome:React.CSSProperties = {
        //     top: top - 74,
        //     left: left + width,
        // };
        //
        // let _styleContent:React.CSSProperties = {
        //     top: top + 180,
        //     left: left + width,
        // };
        //
        // let _styleFooter:React.CSSProperties = {
        //     top: top + height - 140,
        //     left: left + width,
        // };

        return (
            <div
                className={cx(styles.wrapper)}
                onClick={this._onClickWrapper}
            >
                {/*{this._renderText(_styleWelcome, (*/}
                {/*    <span>*/}
                {/*        Check out this guide <br />*/}
                {/*        to learn how to use MintData*/}
                {/*    </span>*/}
                {/*))}*/}

                {/*{this._renderText(_styleContent, (*/}
                {/*    <span>*/}
                {/*        Click play on a video <br />*/}
                {/*        to learn more about each step*/}
                {/*    </span>*/}
                {/*))}*/}

                {/*{this._renderText(_styleFooter, (*/}
                {/*    <span>*/}
                {/*        Navigate these steps <br />*/}
                {/*        by Back / Next buttons*/}
                {/*    </span>*/}
                {/*))}*/}

            </div>
        );
    }
}
